/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {
    Box,
    Heading,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel
} from '@salesforce/retail-react-app/app/components/shared/ui'
import CustomAccordionIcon from '../../../components/customAccordionIcon'
import pdpAccordionStyles from '../../../theme/components/project/pdp-accordion'

const ProductFeature = ({product}) => {
    const {formatMessage} = useIntl()

    return (
        <>
            {/* Long Description */}
            {product?.longDescription && (
                <>
                    <Accordion defaultIndex={[0]} allowMultiple>
                        {/* Shipping Delays & Returns */}
                        <AccordionItem mt={8} borderBottom={'none'} borderColor={'#DADADA'}>
                            {({isExpanded}) => (
                                <>
                                    <AccordionButton padding={0} mt={8}>
                                        <Heading
                                            as={'h2'}
                                            flex="1"
                                            textAlign="left"
                                            fontWeight="extrabold"
                                            fontSize={{base: '2xl', md: 'fontSize32'}}
                                            lineHeight={{base: '8', md: '10'}}
                                        >
                                            {formatMessage({
                                                defaultMessage: 'Features',
                                                id: 'product_description.heading.product_features'
                                            })}{' '}
                                        </Heading>
                                        <CustomAccordionIcon isExpanded={isExpanded} />
                                    </AccordionButton>
                                    <AccordionPanel padding={0} mt={6}>
                                        <Box
                                            dangerouslySetInnerHTML={{
                                                __html: product?.longDescription
                                            }}
                                            sx={{
                                                ...pdpAccordionStyles
                                            }}
                                        />
                                    </AccordionPanel>
                                </>
                            )}
                        </AccordionItem>
                    </Accordion>
                </>
            )}
        </>
    )
}

ProductFeature.propTypes = {
    product: PropTypes.object
}

export default ProductFeature
